import Interval from '../ui/Interval';
import { connect } from 'react-redux';
import { intervalSubmit, skipSubmit, goBack } from '../../actions';

const mapStateToProps = (state, props) => 
  ({
    page: state.page,
    intl: props.intl,
    user: state.user,
    content: state.content
  });

const mapDispatchToProps = dispatch =>
  ({
    onIntervalSubmit(payload) {
       dispatch(
         intervalSubmit(payload)
       );
    },
    onSkipSubmit(payload) {
       dispatch(
         skipSubmit(payload)
       );
    },
    onGoBack(payload) {
       dispatch(
         goBack(payload)
       );
    }
  });

const Container = connect(mapStateToProps, mapDispatchToProps)(Interval);

export default Container;